/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerFindBulkMutationResponse, AiUserFeedbackControllerFindBulk400, AiUserFeedbackControllerFindBulk401 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerFindBulk";

function getAiUserFeedbackControllerFindBulkUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-user-feedback/bulk` as const }  
  return res
}

/**
 * @summary Get latest feedback for multiple request IDs
 * {@link /api/v1/ai-user-feedback/bulk}
 */
export async function aiUserFeedbackControllerFindBulk(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiUserFeedbackControllerFindBulkMutationResponse, ResponseErrorConfig<AiUserFeedbackControllerFindBulk400 | AiUserFeedbackControllerFindBulk401>, unknown>({ method : "POST", url : getAiUserFeedbackControllerFindBulkUrl().url.toString(), ... requestConfig })  
  return res.data
}